export enum RULE_ACTIONS {
  APPLY_PREMIUM = 'APPLY_PREMIUM',
  DONT_BID = 'DONT_BID',
}

export enum RULE_TYPES {
  GEOGRAPHIC = 'GEOGRAPHIC',
  TIME = 'TIME',
  MILEAGE = 'MILEAGE',
  EQUIPMENT = 'EQUIPMENT',
  LANE = 'LANE',
  STEP_PRICING = 'STEP_PRICING',
}

export enum GEOGRAPHIC_CRITERIA_TYPES {
  REGION = 'REGION',
  STATE = 'STATE',
  CITY_STATE = 'CITY, STATE',
  DAT_MARKET = 'DAT MARKET',
}

export enum GEOGRAPHIC_DIRECTIONS {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum MILEAGE_BUCKETS {
  CITY = 'CITY',
  SHORT = 'SHORT',
  MID = 'MID',
  TWEENER = 'TWEENER',
  LONG = 'LONG',
  CROSSCOUNTRY = 'CROSSCOUNTRY',
}

export enum DATE_TYPES {
  DATE_RANGE = 'DATE RANGE',
  NUMBER_OF_DAYS_OUT = 'NUMBER OF DAYS/HOURS OUT',
  WEEKEND = 'WEEKEND',
  SAME_DAY = 'SAME DAY',
  NEXT_DAY = 'NEXT DAY',
}

export interface IShipper {
  id: number
  name: string
}
